/**
 * Minimal toast helper.
 * Wraps `console.info` in test / SSR environments and uses a browser
 * CustomEvent when running in a real document so that a future Toast
 * component can listen without creating a circular dependency.
 */
export type ToastLevel = 'success' | 'error' | 'info';

export function toast(message: string, level: ToastLevel = 'info'): void {
  if (typeof document === 'undefined') {
    // SSR / non-browser
    console.info(`[toast:${level}] ${message}`);
    return;
  }
  const event = new CustomEvent('app:toast', {
    bubbles: true,
    detail: { message, level },
  });
  document.dispatchEvent(event);
}
